import { useQuickMeeting } from './QuickMeetingContext';
import { RecordingPill, RemoteRecordingPill } from './RecordingPill';

/**
 * Where no TopBar is mounted (the launcher, PMS standalone pages, chrome-hidden routes), the
 * recording stays visible bottom-right, so the mic is never live without an indicator (§6.2).
 */
export function FloatingRecordingIndicator() {
  const qm = useQuickMeeting();
  if (!qm) return null;
  const { phase } = qm.local;
  const own = phase === 'recording' || phase === 'paused' || phase === 'saving' || phase === 'save_failed' || phase === 'no_audio';
  if (!own && !qm.remote) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50">
      {own ? <RecordingPill variant="floating" /> : <RemoteRecordingPill variant="floating" />}
    </div>
  );
}
